export default "__VITE_ASSET__Bxx7UJlD__"